import { Provider } from '../types'
import { WeightedEnrichComponent } from './common/weightedenrichcomponent'

class WeightedEnrichPolygons extends WeightedEnrichComponent {
  constructor() {
    super(
      {
        name: 'native.enrichpolygonsweighted',
        group: 'Data Enrichment',
        title: 'Enrich Polygons with Weights',
        description: `
      Uses a data source (either a table or a DO subscription) to enrich another target table using weights to control the enrichment.
      `,
        starred: true
      },
      'ENRICH_POLYGONS_WEIGHTED'
    )

    // adapt the input descriptions to the specific command geo type
    let index = this.inputs.findIndex((i) => i?.name === 'target')
    this.inputs[index].description = this.inputs[index].title = 'Target polygons to be enriched'

    index = this.inputs.findIndex((i) => i?.name === 'target_col')
    this.inputs[index].description = this.inputs[index].title = 'Target polygons geo column'
  }

  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Snowflake]
  }
}

export { WeightedEnrichPolygons }
